import { initializeApp } from "@firebase/app";
import JSEncrypt from "jsencrypt";
import keypair from "keypair";
//import JSEncrypt from "node-jsencrypt";
import React, { ReactNode, useEffect } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useHistory,
  useLocation
} from "react-router-dom";
import { VoiceBox } from "./components/VoiceBox";
import { CreateInvite } from "./pages/CreateInvite";
import Demo from "./pages/Demo";
import { LoggedHome, TopAppBar } from "./pages/Home";
import IMChatBox from "./pages/IMChatBox";
import IMChatOverview from "./pages/IMChatOverview";
import { Landing } from "./pages/Landing";
import { LogIn } from "./pages/LogIn";
import { LogOut } from "./pages/Logout";
import { Register } from "./pages/Register";
import { UserPage } from "./pages/User";
import { UserProfile } from "./pages/UserProfile";
import VChat from "./pages/VChat";
import AppCrypto, { CryptoService, CryptoServiceImpl } from "./services/CryptoService";
import MqttService from "./services/MqttService";
import MainStore from "./stores/MainStore";
import { RootStore } from "./stores/RootStore";
import ChatOverviewList from "./pages//ChatListOverview"
import { BottomNavBar } from "./components/BottomNavBar";
import { Dashboard } from "./pages/Dashboard";
import { Dateship } from "./pages/Dateship";
import { About } from "./static/About";
import './styles/pages.css'
import { NeedForInvite } from "./static/NeedForInvite";
import { SayToMe } from "./static/SayToMe";
import { SelectMatches } from "./pages/SelectMatches";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import Logger from "./services/Logger";
import NotifEnablerComp from "./components/NotifEnablerComp";
import { AnimatePresence } from "framer-motion";
import { getAnalytics } from "firebase/analytics";
import { getMessaging } from "firebase/messaging";
import FCMService from "./services/FCMService";
import { LandingMain } from "./static/LandingMain";
import DumpPlay from "./pages/DumpPlay";
import logo from './eye-mask.svg'
import { Jukebox } from "./pages/Jukebox";
import { UserGuide } from "./static/UserGuide";
import { PrivacyPolicy } from "./static/PrivacyPolicy";
import { SpotifyAuthSuccess } from "./pages/SpotifyAuthSuccess";

//export const mainStore = new MainStore()
export const APP_LOGO = logo
Logger.info('Starting StApp')
export const rootStore = new RootStore()
window.addEventListener('focus', () => {
  Logger.debug('Window in focus')
  rootStore.mainStore.appFocus = true
}, false)

window.addEventListener('blur', () => {
  Logger.debug('Window in blur')
  rootStore.mainStore.appFocus = false
}, false)
//  const cryptoService: CryptoService = new CryptoServiceImpl()
//  const enc = cryptoService.encrypt('Helo', cryptoService.publicKey!)
//  console.log(enc)
//  console.log(cryptoService.decrypt(enc))
// const mqtt = new MqttService()
// mqtt.connect()
// const pair = keypair({bits: 1024})
// const JSEncrypt = require('node-jsencrypt')
// const jsenc = new JSEncrypt()
// const jsenc2 = new JSEncrypt()
// //jsenc.setPrivateKey(pair.private)
// jsenc.setKey(`-----BEGIN PUBLIC KEY-----
// MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgG/i/lsxvq6cOWJekjp+XtaBI+Ee
// oE/XHNDTMUgKXRp9kqoy2mUQsfMLGdoaVNxEaikZO/9mBNyj0ofKmLEvooc4v0lI
// 3O+gTmF7rbculD8apiNehQyvwvbqMfORM32vWTiS8QRHEjG7e2jUOV8qbi+GnRWY
// 3DNqcral75gvu0v/AgMBAAE=
// -----END PUBLIC KEY-----`)
// const enc = jsenc.encrypt('hello')
// console.log('encryption is '+enc)
// console.log('decryption is '+ jsenc2.decrypt(enc))
// const localDec = new JSEncrypt()
// const jsEnc = new JSEncrypt()
//localDec.setPrivateKey(jsEnc.getPrivateKey())
//localDec.setPublicKey(AppCrypto.publicKey!)
//jsEnc.setPrivateKey(jsEnc.getPrivateKey())
// console.log(AppCrypto.privateKey)
// jsEnc.setPrivateKey(AppCrypto.privateKey!)
// export const enc = 'Ow/uQPYAa3JAJtC9IE5eIAZjDpggQcuqGvcmvqT2OShQKKShScQj9jTK9nCkfBjBxH2eG/BbeuMPq0IxgbkukxJmRTwENXqC3Z2phW+ljVrf+lMLK52lfQVw/0335XcFku+VNtlhQ+BXuvTXdXsPMgNpm9DgSsjRaRtli6WFD58='
//export const enc = '"1cWqOvXqrjSxaammDbxH4GZML2gxbbdIiMeWqNMjx2D9Wk9NurBcs96sUi0huT6WnIr/Q31ObOPzm1jH7rOxdKt7d5+/TKT7Q4OYVvk3l0gyiSxBQoAc7v58oG7YFhhzsLW+nb+sCTLCEu+GXhOelIYt47w6NuAZIPe3kCT+ToE="'
//const enc = jsEnc.encrypt('holla')
// console.log(enc)
// jsEnc.decrypt(enc)
// if (enc)
//   console.log(jsEnc.decrypt(enc))

const firebaseConfig = {
  apiKey: "AIzaSyDcwfDYojjD-tUuPs4tgiIW-PspiHM4Ekg",
  authDomain: "saytome-71870.firebaseapp.com",
  projectId: "saytome-71870",
  storageBucket: "saytome-71870.appspot.com",
  messagingSenderId: "194084851974",
  appId: "1:194084851974:web:2e87198f2f9f3bced54e87",
  measurementId: "G-NN499DDVHN"
};

// Initialize Firebase
export const firebaseApp = initializeApp(firebaseConfig);
export const analytics = getAnalytics(firebaseApp);
export const messaging = getMessaging(firebaseApp)
FCMService.registerListeners()
MqttService.connect()



function browserHistoryListener(location: any) {
  console.log('Location changed ' + location.pathname)
  rootStore.uiStore.updateHistoryPath(location.pathname)

}

function StAppContainer() {

  const history = useHistory()
  useEffect(() => {

    let unlisten = history.listen(browserHistoryListener)

    return unlisten
  })

  const location = useLocation()


  function FrontPage() {

    if (rootStore.mainStore.token == null)
      return <LandingMain />
    else
      return <IMChatOverview />

  }

  return (
    <div className='st-app-wrapper'  >
      <div className='st-app flex-column' style={{ position: 'relative', height: '100%' }}>
        {/* A <Switch> looks through its children <Route>s and
                  renders the first one that matches the current URL. */}
        <TopAppBar></TopAppBar>
        <div style={{ flexGrow: 1, overflow: 'hidden', position: 'relative' }}>
          <ToastContainer className='toastify' />
          <AnimatePresence>
            <Switch location={location} key={location.pathname} >
              <Route path="/stapp/register">
                <Register />
              </Route>
              <Route path="/stapp/login">
                <LogIn />
              </Route>
              <Route path="/stapp/home" render={() => (<FrontPage />)} />
              <Route path="/stapp/profile" render={() => (<UserProfile />)} />
              <Route path="/stapp/logout">
                <LogOut />
              </Route>
              <Route path="/stapp/demo">
                <Demo />
              </Route>
              <Route path="/stapp/chat" >
                <VChat />
              </Route>
              <Route path="/stapp/createInvite" >
                <CreateInvite />
              </Route>
              <Route path="/stapp/imchat" render={() => <IMChatBox chatMeta={rootStore.mainStore.currentImChatMeta!} />} />
              <Route path="/stapp/vnotes">
                <ChatOverviewList />
              </Route>
              <Route path="/stapp/imchats">
                <IMChatOverview />
              </Route>
              <Route path="/stapp/dashboard">
                <Dashboard />
              </Route>
              <Route path="/stapp/dateship">
                <Dateship />
              </Route>
              <Route path="/stapp/jukebox">
                <Jukebox />
              </Route>
              <Route path="/stapp/about">
                <About />
              </Route>
              <Route path="/stapp/needforinvite">
                <NeedForInvite />
              </Route>
              <Route path="/saytome">
                <SayToMe />
              </Route>
              <Route path="/stapp/selectMatches">
                <SelectMatches />
              </Route>
              <Route path="/stapp/dumpPlayground">
                <DumpPlay />
              </Route>
              <Route exact path="/stapp/privacyPolicy">
                <PrivacyPolicy />
              </Route>
              <Route exact path="/stapp/jukeboxSpotWork">
                <UserGuide />
              </Route>
              <Route exact path="/stapp/jukeboxVidWork">
                <UserGuide />
              </Route>
              <Route exact path="/stapp/spotifyAuth">
                <SpotifyAuthSuccess />
              </Route>
              <Route path="/:userName">
                <UserPage />
              </Route>
              <Route exact path="/">
                <FrontPage />
              </Route>
            </Switch>
          </AnimatePresence>

        </div>
        <NotifEnablerComp />
        <BottomNavBar />
      </div>
    </div>
  )
}

const StApp = () => {



  return (
    <Router>
      <StAppContainer />
    </Router>

  );


}

export default StApp